import React, { useState } from "react";
import { AdminAuthProvider, useAdminAuth } from "./AdminAuth";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import DashboardPage from "./pages/DashboardPage";
import MembersPage from "./pages/MembersPage";
import ApplicationsPage from "./pages/ApplicationsPage";
import SmsPage from "./pages/SmsPage";
import BirthdaysPage from "./pages/BirthdaysPage";
import SmsLogPage from "./pages/SmsLogPage";
import TemplatesPage from "./pages/TemplatesPage";
import AvantajBasvurulariPage from "./pages/AvantajBasvurulariPage";
import EgitimBasvurulariPage from "./pages/EgitimBasvurulariPage";
import EtkinlikKayitlariPage from "./pages/EtkinlikKayitlariPage";
import IletisimMesajlariPage from "./pages/IletisimMesajlariPage";
import AnlasmaliKurumlarPage from "./pages/AnlasmaliKurumlarPage";
import EtkinliklerPage from "./pages/EtkinliklerPage";
import DuyurularPage from "./pages/DuyurularPage";

const AdminContent: React.FC = () => {
  const { isLoggedIn, loading } = useAdminAuth();
  const [tab, setTab] = useState("dashboard");
  const [smsPreset, setSmsPreset] = useState("");

  // Tüm veri sayfaları artık Firestore'dan kendi okumalarını yapıyor (members, logs,
  // başvurular, içerik). AdminPanel'de localStorage/members/logs state'i KALDIRILDI.

  const handleUseTemplate = (msg: string) => {
    setSmsPreset(msg);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F172A] to-[#1A2540]">
        <i className="fa-solid fa-circle-notch fa-spin text-white text-3xl" />
      </div>
    );
  }

  if (!isLoggedIn) return <AdminLogin />;

  return (
    <AdminLayout activeTab={tab} onTab={setTab}>
      {tab === "dashboard" && <DashboardPage onTab={setTab} />}
      {tab === "members" && <MembersPage />}
      {tab === "applications" && <ApplicationsPage />}
      {tab === "avantajBasvurulari" && <AvantajBasvurulariPage />}
      {tab === "egitimBasvurulari" && <EgitimBasvurulariPage />}
      {tab === "etkinlikKayitlari" && <EtkinlikKayitlariPage />}
      {tab === "iletisimMesajlari" && <IletisimMesajlariPage />}
      {tab === "kurumlar" && <AnlasmaliKurumlarPage />}
      {tab === "etkinlikler" && <EtkinliklerPage />}
      {tab === "duyurular" && <DuyurularPage />}
      {tab === "sms" && (
        <SmsPage preset={smsPreset} onPresetUsed={() => setSmsPreset("")} />
      )}
      {tab === "birthdays" && <BirthdaysPage />}
      {tab === "sms-log" && <SmsLogPage />}
      {tab === "templates" && (
        <TemplatesPage onUseTemplate={handleUseTemplate} onTabChange={setTab} />
      )}
    </AdminLayout>
  );
};

const AdminPanel: React.FC = () => (
  <AdminAuthProvider>
    <AdminContent />
  </AdminAuthProvider>
);

export default AdminPanel;
